import { useEffect, useState, useCallback } from 'react';

const STORAGE_KEY = 'sprite-vault:fb-groups:v1';

const DEFAULT_GROUPS = [
  {
    id: 'fn-sprite-trades',
    name: 'Fortnite Sprite Trades',
    url: 'https://www.facebook.com/groups/fortnitespritetrades',
    builtIn: true,
  },
  {
    id: 'fn-loot-llama-trading',
    name: 'Loot Llama Sprite Trading',
    url: 'https://www.facebook.com/groups/lootllamatrading',
    builtIn: true,
  },
  {
    id: 'fn-collectors',
    name: 'Fortnite Sprite Collectors Hub',
    url: 'https://www.facebook.com/groups/fortnitespritecollectors',
    builtIn: true,
  },
];

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_GROUPS;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || parsed.length === 0) return DEFAULT_GROUPS;
    return parsed;
  } catch {
    return DEFAULT_GROUPS;
  }
}

export function useFacebookGroups() {
  const [groups, setGroups] = useState(load);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(groups));
    } catch { /* ignore */ }
  }, [groups]);

  const addGroup = useCallback((name, url) => {
    const trimmedName = (name || '').trim();
    const trimmedUrl = (url || '').trim();
    if (!trimmedName || !trimmedUrl) return null;
    const safeUrl = /^https?:\/\//i.test(trimmedUrl) ? trimmedUrl : `https://${trimmedUrl}`;
    const item = {
      id: `fb-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      name: trimmedName,
      url: safeUrl,
      builtIn: false,
    };
    setGroups((prev) => [...prev, item]);
    return item;
  }, []);

  const removeGroup = useCallback((id) => {
    setGroups((prev) => prev.filter((g) => g.id !== id));
  }, []);

  const resetToDefaults = useCallback(() => {
    setGroups(DEFAULT_GROUPS);
  }, []);

  return { groups, addGroup, removeGroup, resetToDefaults };
}
